import { getParam } from '../urlParams';

export const getViewJobOriginRef = () => getParam(['ref', 'cid']);
export const getJobActionOrigin = () => getParam('origin');
